import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL } from "../../constant";
import "./ProfilePage.css";
import Header from "../../components/layout/header";
import Footer from "../../components/layout/footer";
import FlashSale from "../Flash Sale/FlashSale";

function ProfilePage() {
  const [user, setUser] = useState({
    name: "",
    lastname: "",
    email: "",
    mobile: "",
  });
  const [address, setAddress] = useState({
    addrId: "",
    houseName: "",
    street: "",
    city: "",
    state: "",
    pinCode: "",
    country: "",
  });
  const [existingAddress, setExistingAddress] = useState([]);
  const [editableAddressId, setEditableAddressId] = useState(null);
  const [originalAddresses, setOriginalAddresses] = useState([]);

  // const [mobile, setMobile] = useState('')

  const toggleEdit = (addrId) => {
    if (editableAddressId === addrId) {
      setEditableAddressId(null);
    } else {
      setEditableAddressId(addrId);
      const addressToEdit = existingAddress.find(
        (addr) => addr.addrId === addrId
      );
      if (addressToEdit) {
        setAddress(addressToEdit);
      }
    }
  };

  useEffect(() => {
    fetchUserData();
    fetchAddresses();
  }, []);

  const fetchUserData = async () => {
    try {
      const userId = localStorage.getItem("userId");
      const response = await axios.get(`${BASE_URL}/users/userByID/${userId}`);
      const userData = response.data;
      setUser({
        name: userData.parName,
        lastname: userData.lastname,
        email: userData.email,
        mobile: userData.mobile1,
      });
    } catch (error) {
      console.error(error);
    }
  };

  const fetchAddresses = async () => {
    try {
      const userId = localStorage.getItem("userId");
      const response = await axios.get(
        `${BASE_URL}/users/getAllAddresses/${userId}`
      );
      if (response.data && response.data.length > 0) {
        setExistingAddress(response.data);
        setOriginalAddresses(response.data); // Store the original addresses
      }
    } catch (error) {
      console.error("Error fetching addresses:", error);
    }
  };

  // const validateMobileNumber = (number) => {
  //   const isValid = /^[0-9]{10}$/.test(number);
  //   if (!isValid) {
  //     setError('Mobile number must be exactly 10 digits.');
  //   } else {
  //     setError('');
  //   }
  //   return isValid;
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));
  };

  const handleAddressChange = (e) => {
    const { name, value } = e.target;
    setAddress((prevAddress) => ({
      ...prevAddress,
      [name]: value,
    }));
  };

  const handleSaveDetails = async () => {
    try {
      const userId = localStorage.getItem("userId");

    const sanitizedname =  user.name.replace(/\s+/g, "") 
    if(sanitizedname==""){
      toast.error("Please enter Valid name")
    }

      // Update user information
      const userData = {
        parName: user.name,
        mobile1: user.mobile,
      };

      if (user.mobile.Value === " ") {
        toast.error("mobile number shouldn't be blank");
      } else if (user.mobile.length !== 10) {
        toast.error("must enter the 10digits mobile number");
      } else {
        toast.success("your profile have been updated!");
      }

      await axios.post(`${BASE_URL}/users/updateUser/${userId}`, userData);
      // toast.success("Your profile have been updated!");
    } catch (error) {
      console.error(error);
      toast.error("Error while updating profile. Please try again.");
    }
  };

  const handleAddAddress = async () => {
    try {
      const userId = localStorage.getItem("userId");

      if (existingAddress.length >= 3) {
        // Check if the user already has 3 addresses
        toast.error("You can't add more than three addresses.");
        return;
      }

    const sanitizedAddressName =  address.houseName.replace(/\s+/g, "") 
    const sanitizedCity =  address.city.replace(/\s+/g, "") 
    const sanitizedStreet =  address.street.replace(/\s+/g, "") 
    const sanitizedState =  address.state.replace(/\s+/g, "") 
    const sanitizedCountry =  address.country.replace(/\s+/g, "") 
    const sanitizedPinCode =  address.pinCode.replace(/\s+/g, "") 

    if( sanitizedAddressName == ""){
      toast.error("Please Enter valid House Name")
      return;
    }
    if( sanitizedCity == ""){
      toast.error("Please Enter valid City Name")
      return;
    } 
    if( sanitizedStreet == ""){
      toast.error("Please Enter valid Street Name")
      return;
    } 
    if( sanitizedState == ""){
      toast.error("Please Enter valid State Name")
      return;
    } 
    if( sanitizedCountry == ""){
      toast.error("Please Enter valid Country Name")
      return;
    } 
    if( sanitizedPinCode == ""){
      toast.error("Please Enter valid Pin code")
      return;
    }

      // Generate a new addrId based on the existing addresses
      const newAddrId =
        existingAddress.length > 0
          ? Math.max(...existingAddress.map((addr) => parseInt(addr.addrId))) +
            1
          : 1;

      const newAddressData = {
        ...address,
        addrId: newAddrId.toString(),
      };

      await axios.post(
        `${BASE_URL}/users/addNewAddress/${userId}`,
        newAddressData
      );

      fetchAddresses();
      toast.success("Address added successfully!");

      setAddress({
        addrId: "",
        houseName: "",
        street: "",
        city: "",
        state: "",
        pinCode: "",
        country: "",
      });
    } catch (error) {
      console.error(error);
      toast.error("Error while adding Address. Please try again.");
    }
  };

  const handleAddressSave = async () => {
    try {
      const userId = localStorage.getItem("userId");
      const updatedAddress = {
        ...address,
      };

      const sanitizedAddressName =  address.houseName.replace(/\s+/g, "") 
      const sanitizedCity =  address.city.replace(/\s+/g, "") 
      const sanitizedStreet =  address.street.replace(/\s+/g, "") 
      const sanitizedState =  address.state.replace(/\s+/g, "") 
      const sanitizedCountry =  address.country.replace(/\s+/g, "") 
      const sanitizedPinCode =  address.pinCode.replace(/\s+/g, "") 
  
      if( sanitizedAddressName == ""){
        toast.error("Please Enter valid House Name")
        return;
      }
      if( sanitizedCity == ""){
        toast.error("Please Enter valid City Name")
        return;
      } 
      if( sanitizedStreet == ""){
        toast.error("Please Enter valid Street Name")
        return;
      } 
      if( sanitizedState == ""){
        toast.error("Please Enter valid State Name")
        return;
      } 
      if( sanitizedCountry == ""){
        toast.error("Please Enter valid Country Name")
        return;
      } 
      if( sanitizedPinCode == ""){
        toast.error("Please Enter valid Pin code")
        return;
      }

      await axios.post(
        `${BASE_URL}/users/updateAddress/${userId}`,
        updatedAddress
      );

      setEditableAddressId(null);
      fetchAddresses();
      toast.success("Address updated successfully!");
    } catch (error) {
      console.error(error);
      toast.error("Error updating address. Please try again.");
    }
  };

  return (
    <>
    
      <Header />
      <div className="profile-page">
        <div className="profile-container">
          <h2>Account</h2>
          <div className="user-info">
            <h3>User Information</h3>
            <div className="input-grid">
              <input
                type="text"
                name="name"
                value={user.name}
                onChange={handleChange}
                placeholder="Full Name"
              />
              <input
                type="email"
                name="email"
                value={user.email}
                onChange={handleChange}
                placeholder="Email"
                readOnly
              />
              <input
                type="tel"
                name="mobile"
                value={user.mobile}
                onChange={handleChange}
                required
                maxLength={"10"}
                minLength={"10"}
                size={"10"}
                placeholder="Mobile"
              />
            </div>
            <div className="save-btn-container">
              <button className="save-button" onClick={handleSaveDetails}>
                Save Details
              </button>
            </div>
          </div>
          <div className="shipping-address">
            <h3>Shipping Address</h3>
            <div className="input-grid" id="shipping-grid">
              <input
                type="text"
                name="houseName"
                value={address.houseName}
                onChange={handleAddressChange}
                placeholder="House Name"
                required
              />
              <input
                type="text"
                name="street"
                value={address.street}
                onChange={handleAddressChange}
                placeholder="Street"
                required
              />
              <input
                type="text"
                name="city"
                value={address.city}
                onChange={handleAddressChange}
                placeholder="City"
                required
              />
              <input
                type="text"
                name="state"
                value={address.state}
                onChange={handleAddressChange}
                placeholder="State"
                required
              />
              <input
                type="text"
                name="pinCode"
                value={address.pinCode}
                onChange={handleAddressChange}
                placeholder="Pin Code"
                required
              />
              <input
                type="text"
                name="country"
                value={address.country}
                onChange={handleAddressChange}
                placeholder="Country"
                required
              />
              <p className="note">Note: User can save up to 3 addresses</p>
            </div>
          </div>
          <div className="save-btn-container">
            <button className="save-button" onClick={handleAddAddress}>
              Add Address
            </button>
          </div>
        </div>

        {existingAddress.length > 0 ? (
          existingAddress.map((add) => (
            <div className="home-address" key={add.addrId}>
              <div className="home-header">
                <h3>Home</h3>
                <button
                  className="edit-button"
                  onClick={() => toggleEdit(add.addrId)}
                >
                  {editableAddressId === add.addrId ? "Cancel" : "Edit"}
                </button>
              </div>
              <div className="input-grid" id="home-address-inputs">
                <input
                  type="text"
                  name="houseName"
                  value={
                    add.addrId === editableAddressId
                      ? address.houseName
                      : add.houseName
                  }
                  onChange={handleAddressChange}
                  placeholder="House Name"
                  readOnly={add.addrId !== editableAddressId}
                />
                <input
                  type="text"
                  name="street"
                  value={
                    add.addrId === editableAddressId
                      ? address.street
                      : add.street
                  }
                  onChange={handleAddressChange}
                  placeholder="Street"
                  readOnly={add.addrId !== editableAddressId}
                />
                <input
                  type="text"
                  name="city"
                  value={
                    add.addrId === editableAddressId ? address.city : add.city
                  }
                  onChange={handleAddressChange}
                  placeholder="City"
                  readOnly={add.addrId !== editableAddressId}
                />
                <input
                  type="text"
                  name="state"
                  value={
                    add.addrId === editableAddressId ? address.state : add.state
                  }
                  onChange={handleAddressChange}
                  placeholder="State"
                  readOnly={add.addrId !== editableAddressId}
                />
                <input
                  type="text"
                  name="pinCode"
                  value={
                    add.addrId === editableAddressId
                      ? address.pinCode
                      : add.pinCode
                  }
                  onChange={handleAddressChange}
                  placeholder="Pin Code"
                  readOnly={add.addrId !== editableAddressId}
                />
                <input
                  type="text"
                  name="country"
                  value={
                    add.addrId === editableAddressId
                      ? address.country
                      : add.country
                  }
                  onChange={handleAddressChange}
                  placeholder="Country"
                  readOnly={add.addrId !== editableAddressId}
                />
              </div>
              {editableAddressId === add.addrId && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "20px",
                  }}
                >
                  <button
                    className="save-address-button"
                    style={{
                      background: "#FFC55B",
                      border: "none",
                      padding: "8px 20px",
                      borderRadius: "5px",
                      fontSize: "20px",
                    }}
                    onClick={handleAddressSave}
                  >
                    Save Address
                  </button>
                </div>
              )}
            </div>
          ))
        ) : (
          <div className="home-address">
            <div className="home-header">
              <h3>No Address Found</h3>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
}

export default ProfilePage;
